import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import {
    PricingLocationSaveRequestData,
    PricingLocationSaveResponseData,
    PricingResponse,
    PricingSaveRequestData,
    PricingSaveResponseData,
    PricingSortRequestData,
    PricingType,
    ResponseData,
} from "../../../../graphql/types"
import { AuditData } from "../../../../events/Setting/types"

export const fetchSpecialPricingsData = (headers: Record<string, any>): Promise<Maybe<PricingResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query pricings {
                    pricings {
                        data {
                            id
                            name
                            absolute
                            percentage
                            isOrderLevel
                            isItemLevel
                            isActive
                            isAutoApply
                            sortIndex
                            autoApplyHours {
                                id
                                name
                                timeSpans {
                                    start
                                    duration
                                    isExclusion
                                }
                            }
                        }
                        overrides {
                            locationId
                            data {
                                id
                                isActive
                                isAutoApply                                
                                autoApplyHours {
                                    id
                                    name
                                    timeSpans {
                                        start
                                        duration
                                        isExclusion
                                    }
                                }
                            }
                        }
                        
                    }
                }
            `,
            operationName: "pricings",
        },
    }).then(response => {
        if (response && response.data && response.data.pricings) {
            return response.data.pricings
        }

        return null
    })

export const pricingSave = (
    headers: Record<string, any>,
    data: PricingSaveRequestData
): Promise<Maybe<PricingSaveResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation pricingSave($data: PricingSaveRequestData!) {
                    pricingSave(data: $data) {
                      data {
                            id
                            name
                            absolute
                            percentage
                            isOrderLevel
                            isItemLevel
                            isActive
                            isAutoApply
                            sortIndex
                            autoApplyHours {
                                id
                                name
                                timeSpans {
                                    start
                                    duration
                                    isExclusion
                                }
                            }
                        }
                    }
                }
            `,
            operationName: "pricingSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.pricingSave
    })

export const pricingLocationSave = (
    headers: Record<string, any>,
    data: PricingLocationSaveRequestData
): Promise<Maybe<PricingLocationSaveResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation pricingLocationSave($data: PricingLocationSaveRequestData!) {
                    pricingLocationSave(data: $data) {
                      data {
                        locationId
                        data {
                           id
                           isActive
                           isAutoApply
                           autoApplyHours {
                                id
                                name
                                timeSpans {
                                    start
                                    duration
                                    isExclusion
                                }
                            }
                        }
                      }
                    }
                }
            `,
            operationName: "pricingLocationSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.pricingLocationSave
    })
//

export const pricingDeleteApi = (
    headers: Record<string, any>,
    id: string,
    auditData: AuditData,
    pricingType?: PricingType
): Promise<ResponseData> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation pricingDelete($id: String!, $auditData: AuditData, $pricingType: PricingType) {
                    pricingDelete(id: $id, auditData: $auditData, pricingType: $pricingType) {
                      success
                    }
                }
            `,
            operationName: "pricingDelete",
            variables: {
                id: id,
                auditData: auditData,
                pricingType: pricingType,
            },
        },
    }).then(response => {
        return response.pricingDelete
    })

export const pricingSort = (headers: Record<string, any>, data: PricingSortRequestData): Promise<Maybe<ResponseData>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation pricingSort($data: PricingSortRequestData!) {
                    pricingSort(data: $data) {
                       success
                    }
                }
            `,
            operationName: "pricingSort",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        return response.data.pricingSort
    })
